export const PADDING_ALL = 'padding-all';
export const PADDING_HORIZONTAL = 'padding-horizontal';
export const PADDING_VERTICAL = 'padding-vertical';
export const PADDING_TOP = 'padding-top';
export const PADDING_BOTTOM = 'padding-bottom';
export const PADDING_LEFT = 'padding-left';
export const PADDING_RIGHT = 'padding-right';
export const PADDING_NONE = 'padding-none';
export const PADDING_NO_TOP = 'padding-no-top';
export const PADDING_NO_BOTTOM = 'padding-no-bottom';